import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'content',
  label: 'Content / Policy Section',
  description: 'Policies and other text pages, or a questions-and-answers block with a heading beside an accordion.',
  supportedPages: ['privacy-policy', 'terms-of-service', 'shipping-policy', 'return-policy', 'about', 'contact'],
  variants: [
    { id: 'v1', label: 'V1 (Clean Layout)' },
    { id: 'v2', label: 'V2 (With Table of Contents)' },
    {
      id: 'v3',
      label: 'Questions (heading beside an accordion)',
      fields: [
        { key: 'eyebrow', label: 'Eyebrow', type: 'localized-string', default: 'Good to know' },
        { key: 'highlight', label: 'Highlighted words', type: 'localized-string', default: 'answered.', help: 'Shown in amber on their own line under the title.' },
        { key: 'subtitle', label: 'Line under the heading', type: 'localized-text', default: 'The questions we hear most often, answered by the team.' },
        { key: 'helpText', label: 'Help button text', type: 'localized-string', default: 'Need help?' },
        { key: 'helpLink', label: 'Help button link', type: 'string', default: '/contact' },
        {
          key: 'faqs',
          label: 'Questions and answers',
          type: 'array',
          help: 'Shown as an accordion (also published as FAQ structured data).',
          itemSchema: [
            { key: 'question', label: 'Question', type: 'string' },
            { key: 'answer', label: 'Answer', type: 'text' },
          ],
          default: [
            { question: 'How do I place an order?', answer: 'Pick a size, add the piece to your cart and check out. You can also call or message us and we will place it for you.' },
            { question: 'Which payment methods can I use?', answer: 'Cash on delivery, cards and mobile banking.' },
            { question: 'How long does delivery take?', answer: 'Usually one to two days inside the city and three to five days elsewhere.' },
            { question: 'Can I swap a size?', answer: 'Yes, within 7 days, as long as the piece is unworn with its tags on.' },
          ],
        },
      ],
    },
  ],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string' },
    { key: 'content', label: 'HTML Content', type: 'rich-text' },
  ],
}
